import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs/Observable'
import { AuthService } from '../../services/auth.services'

@Injectable()
export class ClientGuard implements CanActivate {
    constructor(private authService: AuthService,
                private router: Router) {
    }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): Observable<boolean>|Promise<boolean>|boolean {
        //
        if (this.authService.getItem('user')) {
            // this.socketService.initSocket()
            return true
        } else {
            this.router.navigateByUrl('/client/login-token')
            return false
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/guarad/client.guard.ts